// Native replacements for RSVP helpers that have no direct `Promise` equivalent.

// hash resolves an object of promises to an object of their values, keyed the
// same way. Every promise is already running when passed in, so they settle
// concurrently, and it rejects with the first rejection, like `Promise.all`.
// Prefer it over destructuring `Promise.all`, which pairs names with results
// by position and silently mismatches them when the array is reordered.
export async function hash<T extends Record<string, unknown>>(
  object: T,
): Promise<{ [K in keyof T]: Awaited<T[K]> }> {
  const keys = Object.keys(object);
  const values = await Promise.all(Object.values(object));
  return Object.fromEntries(keys.map((key, i) => [key, values.at(i)])) as {
    [K in keyof T]: Awaited<T[K]>;
  };
}
